import { Box, List, ListItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SqoCertificate } from '@/common';
import CertificateListItem from './Certificate';

type CertificateListProps = {
  certificates?: SqoCertificate[];
  visitId: string;
};

const CertificateList = ({ certificates, visitId }: CertificateListProps) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <List>
        {!!certificates &&
          certificates.map((certificate) => (
            <CertificateListItem key={certificate.id} certificate={certificate} visitId={visitId} />
          ))}
      </List>
    </Box>
  );
};

export default CertificateList;
